/**
 * VendorBadge — small persistent badge in top right of every vendor mode screen.
 * Makes the active mode always identifiable at a glance.
 */
export default function VendorBadge() {
  return (
    <div
      className="fixed top-3 right-3 z-50 px-2 py-0.5 rounded-full bg-[#F59E0B] text-[9px] font-black text-[#1C1C1E] tracking-wider shadow-sm"
      data-testid="vendor-badge"
    >
      VENDOR
    </div>
  );
}
